
import Vue from 'vue';
import { mapState } from 'vuex';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';

export default Vue.extend({
	name: 'RunnitAccountSelectionButton',
	props: {
		isSideNavDesignExpanded: { type: Boolean, default: false },
		isSideNavDesignCollapsed: { type: Boolean, default: false },
	},
	computed: {
		...mapState([
			'loadingTeam',
			'loadingUser',
			'team',
			'runnitState',
		]),
		isRunnitsOwnerSelectionLoading () {
			if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM) {
				return !!this.loadingTeam;
			}
			return !!this.loadingUser;
		},
		runnitsOwnerSelectionLabel () {
			let label: string = '';

			if (this.isRunnitsOwnerSelectionLoading) return 'Loading...';
			if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.USER) {
				label = 'Personal';
			} else if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM) {
				label = this.team ? this.team.name : 'No team selected';
			}

			return label;
		},
		firstLettersOfAccountSelectionIconName () {
			if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM && this.team) {
				let firstToLetters = this.team.name.slice(0,2);
				return firstToLetters.charAt(0).toUpperCase() + firstToLetters.slice(1).toLowerCase();
			} else if (this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.USER) {
				return 'P';
			}
			return '';
		},
	},
	methods: {
		handleClick () {
			if (this.isRunnitsOwnerSelectionLoading) return;
			this.$emit('click');
		},
	},
});
